import React from 'react'
import GenericGrid from '../../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useAccount from './useAccount'
import { formatDateValue } from '../../../sharedcomponents/1elements/Fields/FormikDatePicker'
import { Loader } from '../../../components/1elements'
import { pageVars } from '../../../pages/const/pageVars'

const {codeText, headerText, showWarning, } = pageVars.ACCOUNTS

const pageSettings = {
  showWarning: showWarning || false,
  codeText: codeText || 'pageCodeText',
  headerText: headerText || 'pageHeaderText',
}

const AccountSummary = () => {
  const defaultFetchParameter = {
    include: ['counts'],
    sort: '+name',
    page: 0,
    per_page: 20
  }
  const {
    loadContracts,
    bulkUpdateContractsCallBack,
    typeIdToDisplayName,
    accountTypes
  } = useAccount()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty,
    loading,
  } = useGridWrapper(
    pageSettings.codeText,
    bulkUpdateContractsCallBack,
    pageSettings.showWarning
  )
  
  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 250, sortable: true },
    {
      field: 'total_entities',
      headerName: 'Entities',
      width: 150,
      sortable: true
    },
    {
      field: 'total_assets',
      headerName: 'Locations',
      width: 150,
      sortable: true
    },
    {
      field: 'expiry',
      headerName: 'Expiry Date',
      width: 150,
      sortable: true
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 300,
      sortable: true
    },
    {
      field: 'active',
      headerName: 'Status',
      width: 200,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = await loadContracts(arg)
    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        description: one.description,
        total_entities: one.stats?.find(r => r.type === 'entities')?.count,
        total_assets: one.stats?.find(r => r.type === 'assets')?.count,
        expiry:
          (one.expires_at && formatDateValue(one.expires_at, 'toYYYY-MM-DD')) ||
          '',
        // $user: one.object_counts.find(r => r.type === 'user').count,
        // $feature: one.object_counts.find(r => r.type === 'feature').count,
        // $territory: one.object_counts.find(r => r.type === 'territory').count,
        active: one.suspended_at ? false : true
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <>
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={pageSettings.headerText}
          containedEntityType={'NA'}
          editMode={editMode}
          setEditMode={setEditMode}
          Account
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          listOfTypes={accountTypes}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            pageCodeText={pageSettings.codeText}
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
            showWarning={pageSettings.showWarning}
          />
        </GridWrapper>
      </div>
    </div>
    {loading && <Loader />}
    </>
  )
}
export default React.memo(AccountSummary)
